import React, { createContext, useContext, useState } from 'react';

const UserContext = createContext({ page: 0, size: 10, searchWrd: '', memberTypeCd : '' });

const UserProvider = ({ children }) => {
    const [options, setOptions] = useState({ page: 0, size: 10, searchWrd: '', memberTypeCd : '' });

    const value = {
        options,
        setOptions
    };

    return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

const useUserContext = () => {
    return useContext(UserContext);
};

export { UserProvider, useUserContext };
